import React, { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { Card } from "./MobileShell";
import { deleteMyAccount } from "../lib/api";

export default function DeleteAccountCard({ token, onDeleted }) {
  const [open, setOpen] = useState(false);
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    setErr("");
    setBusy(true);
    try {
      await deleteMyAccount(token, pin);
      onDeleted();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not delete account");
      setBusy(false);
    }
  };

  return (
    <Card className="mb-5" data-testid="profile-delete-account">
      <div className="eyebrow text-[var(--lc-muted)] mb-1">Privacy & data</div>
      {!open ? (
        <button onClick={() => setOpen(true)} className="text-sm text-red-700 font-semibold" data-testid="delete-account-open">
          Delete my account
        </button>
      ) : (
        <div>
          <div className="flex items-start gap-2 text-[12px] text-red-800 bg-red-50 border border-red-200 rounded-md p-3">
            <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
            This permanently deletes your account, logs, plan progress, lab files, coach chats and devices. It cannot be undone.
          </div>
          <input
            type="password"
            inputMode="numeric"
            maxLength={6}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
            placeholder="Enter your PIN to confirm"
            className="mt-3 w-full px-3 py-2.5 bg-[var(--lc-cream)] border border-[var(--lc-line)] rounded-md text-sm tracking-[0.3em]"
            data-testid="delete-account-pin"
          />
          {err && <div className="mt-2 text-[11px] text-red-700" data-testid="delete-account-error">{err}</div>}
          <div className="mt-3 grid grid-cols-2 gap-2">
            <button onClick={() => { setOpen(false); setPin(""); setErr(""); }} className="py-2.5 border border-[var(--lc-line)] text-[11px] font-bold tracking-[0.14em] uppercase rounded-md" data-testid="delete-account-cancel">
              Cancel
            </button>
            <button
              onClick={submit}
              disabled={busy || pin.length < 4}
              className="py-2.5 bg-red-700 text-white text-[11px] font-bold tracking-[0.14em] uppercase rounded-md disabled:opacity-50 inline-flex items-center justify-center gap-1.5"
              data-testid="delete-account-confirm"
            >
              {busy && <Loader2 className="h-3 w-3 animate-spin" />} Delete forever
            </button>
          </div>
        </div>
      )}
    </Card>
  );
}
